export default __webpack_public_path__ + "bd3f9bf32f82e45e037fa43014bf77a0.svg";